import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ConfigProvider, theme } from 'antd'
import itIT from 'antd/locale/it_IT'
import dayjs from 'dayjs'
import 'dayjs/locale/it'
import { SpeechProvider } from './contexts/SpeechContext'
import { ThemeProvider, useTheme } from './contexts/ThemeContext'
import App from './App'
import './index.css'

// Configura dayjs in italiano
dayjs.locale('it')

// Configura React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minuti
    },
  },
})

const ThemedApp = () => {
  const { isDark } = useTheme()

  return (
    <ConfigProvider
      locale={itIT}
      theme={{
        algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
        token: {
          colorPrimary: '#1890ff',
          borderRadius: 6,
          ...(isDark ? {
            colorBgContainer: '#1d1d1d',
            colorBgElevated: '#262626',
            colorBgLayout: '#0f0f0f',
            colorBorder: '#303030',
            colorBorderSecondary: '#262626',
            // Text contrast: WCAG AA on #1d1d1d bg
            colorText: 'rgba(255,255,255,0.88)',
            colorTextSecondary: 'rgba(255,255,255,0.72)',   // ~10:1
            colorTextTertiary: 'rgba(255,255,255,0.55)',    // ~7:1
            colorTextQuaternary: 'rgba(255,255,255,0.38)',  // ~4.8:1
            colorTextDescription: 'rgba(255,255,255,0.72)', // Statistic.title, Form help
            colorTextDisabled: 'rgba(255,255,255,0.30)',
            colorFillAlter: 'rgba(255,255,255,0.05)',
            colorFillSecondary: 'rgba(255,255,255,0.08)',
            colorFillTertiary: 'rgba(255,255,255,0.04)',
          } : {}),
        },
      }}
    >
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <SpeechProvider>
          <App />
        </SpeechProvider>
      </BrowserRouter>
    </ConfigProvider>
  )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <ThemedApp />
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>
)
